import React from "react";
import { FormattedMessage } from "react-intl";
import { Space } from "@masterteam/mt-design-react";
import { ReactComponent as UpdateIcon } from "../../assets/images/update-icon.svg";
import { ReactComponent as RequiredIcon } from "../../assets/images/required-update.svg";
import styles from "./KPIUpdateIndicator.module.scss";

function KPIUpdateIndicator({ item, iconOnly = false }) {
  return (
    <Space align="center" className={styles.kpiUpdate}>
      {item.RequireUpdate ? (
        <>
          <RequiredIcon className={styles.requiredIcon} />
          {!iconOnly && <FormattedMessage id="status.required-updated" />}
        </>
      ) : (
        <>
          <UpdateIcon className={styles.updatedIcon} />
          {!iconOnly && <FormattedMessage id="status.updated" />}
        </>
      )}
    </Space>
  );
}

export default KPIUpdateIndicator;
